(function(module) {
try {
  module = angular.module('app');
} catch (e) {
  module = angular.module('app', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('common/lock-status.html',
    '<span class="fa fa-fw lock-status" ng-class="{\n' +
    '    \'fa-lock\': status == \'LOCKED\' || status == \'WORKING_COPY\',\n' +
    '    \'text-danger\': status == \'LOCKED\',\n' +
    '    \'text-success\': status == \'WORKING_COPY\'\n' +
    '  }" title="{{\n' +
    '    status, select,\n' +
    '    FREE { {{ \'lockStatus.free\' | messageFormat }} }\n' +
    '    LOCKED { {{ \'lockStatus.locked\' | messageFormat }} }\n' +
    '    WORKING_COPY { {{ \'lockStatus.workingCopy\' | messageFormat }} }\n' +
    '    other { }\n' +
    '  }}"></span>');
}]);
})();
